// @todo: Refactor to constants when API will be ready
const chargesListFields = [
    {
      field: 'id',
      title: 'Id',
      hidden: true,
    },
    {
      field: 'expenseAccountId',
      title: 'expenseAccountId',
      hidden: true,
    },
		// {
		// 	field: 'commands',
		// 	title: 'Actions',
		// 	cell: 'commands',
		// 	sortable: false,
		// 	locked: true,
		// 	hidden: false,
		// 	width: 80,
		// },
    {
      title: 'Type',
      field: 'accountName',
      cell: 'navigation',
    },
    {
      title: 'Description',
      field: 'description',
    },
    {
      title: 'Charge to Customer',
      field: 'isNoCharge',
      cell: 'invertedCheckMark',
    },
    {
      title: 'In-House Expense',
      field: 'isNoCharge',
      cell: 'checkMark',
    },
    {
      title: 'Amount',
      field: 'amount',
      cell: 'formatCurrencyConverted'
    },
    {
      field: '',
      title: '',
      cell: 'deletecommands',
      sortable: false,
      hidden: false,
      locked: true,
      width: 30,
    },
  ];

  export default chargesListFields;